import { Brands } from "../modules/brands";

export const BrandsPage = () => {
  return <Brands />;
};
